(ns ncr.fragment-types.attachments
  (:require
   [cljs.core.async :as async :refer-macros [go]]
   [clojure.core.match :refer [match]]
   [clojure.string :as str]
   [lambdaisland.glogi :as log]
   [taoensso.encore :as e]
   [uix.core.alpha :as uix]
   [ncr.etc.util :as u]
   [ncr.backend :as b]
   [ncr.fragment.attachments-backend :as ba]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.pf :as pf]
   [ncr.etc.rhf :as rhf]
   [ncr.etc.modal :as m]
   [ncr.etc.alert :as a]
   [ncr.widgets.core :as w]
   [ncr.me :as me]
   [ncr.navigate :as n]
   [ncr.fragment.folder :as fragment-folder]
   [ncr.fragment.label :as fragment-label]
   [ncr.fragment.common :as fragment-common]
   [ncr.widgets.dropzone :as wdz]))

(defn default-fragment-name [file]
  (u/base-file-name
    (.-name file)))

(defn !create-fragment
  [{:keys [name description files folder labels tentative]
    :or {description "" tentative false}}]
  (go
    (let
      [progress-base {:title "Create Fragment"}
       progress (a/progress progress-base)]
      (<!
        (a/!operation*
          {:operation-title "Create Fragment"
           :success-title "Fragment Created"
           :body-fn
           (fn [id]
             [:a
              {:href
               (n/fragment-href
                 {:slug (fragment-common/fragment-name->slug name)
                  :id id})}
              name])}
          progress
          (go
            (u/error-m
              [_
               (async/>! progress (merge progress-base {:body "Uploading..."}))

               attachments
               (<!
                 (->> files
                   (map ba/!upload*)
                   (async/merge)
                   (async/reduce conj [])))

               attachments
               (filter (complement u/m-fail?) attachments)

               _
               (async/>! progress (merge progress-base {:body "Creating..."}))

               reference-id
               (let
                 [queries
                  (concat
                    [[:create
                      [:fragment_create
                       {:name :$name
                        :description :$description
                        :folder folder
                        :tentative tentative}
                       [:id]]]]

                    (when (seq labels)
                      [[:labels
                        [:reference_edit_labels
                         {:id :?document-id
                          :op :add
                          :labels (into [] labels)}]]])

                    (map
                      (fn [[attachment-id _]]
                        [(str "confirm_" attachment-id)
                         [:upload_confirm
                          {:id attachment-id}]])
                      attachments)

                    (map
                      (fn [[attachment-id file-name]]
                        [(str "attach_" attachment-id)
                         [:attachment_attach
                          {:reference :?document-id
                           :attachment attachment-id
                           :fileName file-name}
                          [:id]]])
                      attachments))]

                 (u/error-m [result (<! (b/!multi-mutation queries {:$description description :$name name}))]
                   (-> result :create :id)))]
              reference-id)))))))

(defn- c-add-files [props open]
  [pf/c-button
   (w/merge-props
     {:class [:pf-l-flex-item :pf-u-align-self-flex-end]
      :variant :link
      :icon [w/c-mdi-icon {:icon :file-plus-outline}]
      :on-click open}
     props)
   "Add File..."])

(defn- c-new-fragment-body [{:keys [submit control] :as form} me]
  [pf/c-form {:on-submit submit}
   [pf/c-grid
    [pf/c-grid-item {:span 10}
     (let [id (uix/memo #(gensym) [])]
       [rhf/c-form-group {:label "Name" :is-required true :field-id id} :name form
        [fragment-common/c-name-input id form []]])]

    [pf/c-grid-item {:span 2}
     (let [id (uix/memo #(gensym) [])]
       [rhf/c-form-group {:label "Folder" :is-required true :field-id id} :folder form
        [fragment-folder/c-folder-selector id form :folder
         (u/index-by :id
           (conj
             (me/shared-folders me)
             (me/inbox-folder me)))]])]

    [fragment-common/c-fragment-form-description form 60 false]

    (let [id (uix/memo #(gensym) [])]
      [rhf/c-form-group {:label "Labels" :is-required false :field-id id} :labels form
       [fragment-label/c-labels-selector
        {:name :labels :form form :id id}
        (get-in (uix/context me/*context*) [:cluster :labels])]])]

   [rhf/c-controller
    {:name :files
     :control control
     :render
     (fn [props]
       (let
         [{:keys [get-root-props get-input-props is-drag-active open]}
          (wdz/use-dropzone
            {:no-click true
             :on-drop-accepted
             (fn [files]
               (let [actual (some-> props :field :value)]
                 ((-> props :field :on-change) (concat actual files))))})
          files (some-> props :field :value)
          files? (seq files)]

         [pf/l-flex
          {:direction :column
           :style {:position :relative :padding-bottom 32}}
          (let
            [pointer-events
             {:style
              {:pointer-events
               (if is-drag-active
                 :none :auto)}}]
            [:div.ncr-new-fragment-attachments
             (get-root-props)
             [:input (get-input-props)]
             [w/c-dropzone-target (not is-drag-active)]
             (when files?
               [c-add-files pointer-events open])
             (if files?
               [pf/c-list
                {:class [:pf-l-flex-item :ncr-m-no-pointer-events :pf-u-pb-sm]
                 :variant :plain}
                (into [:<>]
                  (map-indexed
                    (fn [index file]
                      [pf/c-list-item
                       [pf/c-card {:is-compact true}
                        [pf/c-card-header
                         [pf/c-card-actions
                          [pf/c-button (w/merge-props {:variant :plain :class [:pf-u-pr-0]} pointer-events)
                           [w/c-mdi-icon
                            {:icon :close
                             :on-click
                             #((-> props :field :on-change) (u/remove-nth index files))}]]]
                         [pf/c-card-title {:class :pf-u-font-weight-normal} (.-name file)]]]])
                    files))]
               [pf/c-empty-state {:class :ncr-m-no-pointer-events}
                [c-add-files pointer-events open]
                [pf/c-title {:size :xs}
                 "(You can also drop files here)"]])])]))}]])

(defn- c-new-fragment [me defaults]
  (let
    [ref (uix/ref)
     {:keys [submit watch set-value] :as form}
     (rhf/use-form
       {:shouldFocusError false
        :default-values
        (merge defaults
          (when (nil? (:folder defaults))
            {:folder (:id (me/inbox-folder me))}))})
     modal-id :new-fragment-modal]

    (uix/with-effect []
      (watch
        (fn [{:keys [name files]} update]
          (match update
            {:name :files :type :change}
            (when (and (str/blank? name) (seq files))
              (set-value :name (default-fragment-name (first files)) {}))
            _
            nil))))

    (m/use-submit-form modal-id ref submit)

    [m/c-modal
     {:title "New Documents Fragment"
      :variant :medium
      :is-overflow-visible false
      :id modal-id
      :ref ref
      :actions
      [[pf/c-button
        {:variant :primary
         :on-click submit}
        "Create"]

       [pf/c-button
        {:variant :link :on-click #(m/close! nil)} "Cancel"]]}
     [c-new-fragment-body form me]]))

(defn !create-fragment-ui [me defaults]
  (go
    (if-let [{:keys [name description folder labels files] :as fields}
             (<! (m/!modal #'c-new-fragment me defaults))]
      (when (<! (!create-fragment fields))
        (ps/pub! [:me/load]))
      [:error :cancel])))
